import type { ReactElement } from 'react';
import React from 'react';
import type { PaletteTypes, SizeTypes, TagAlertProps } from './TagAlert.types';
import { TagAlertPalette, TagAlertSize } from './TagAlert.types';

import { Box } from './subcomponents/Box';
import { AlertIcon } from './subcomponents/AlertIcon';
import { TextParent } from './subcomponents/TextParent';

export const TagAlert = (props: TagAlertProps): ReactElement => {
  const {
    palette = TagAlertPalette.success as PaletteTypes,
    size = TagAlertSize.small as SizeTypes,
    children,
    testID,
  } = props;

  return (
    <Box testID={testID} palette={palette} size={size}>
      <AlertIcon testID={testID?.concat('.icon')} {...{ palette, size }}>
        {children}
      </AlertIcon>
      <TextParent testID={testID?.concat('.text')} {...{ palette, size }}>
        {children}
      </TextParent>
    </Box>
  );
};
